import { render, staticRenderFns } from "./SupplierFilter.vue?vue&type=template&id=39140b4c&"
import script from "./SupplierFilter.vue?vue&type=script&lang=ts&"
export * from "./SupplierFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports